import { render } from "./StarOfTheTeam.vue?vue&type=template&id=09ce74f5"
import script from "./StarOfTheTeam.vue?vue&type=script&lang=js"
export * from "./StarOfTheTeam.vue?vue&type=script&lang=js"
script.render = render

export default script